var map = {
	"./add-2.svg": 56552,
	"./add-3.svg": 68921,
	"./add.svg": 99585,
	"./arrow-down-solid.svg": 28166,
	"./arrow-down.svg": 75432,
	"./arrow-left.svg": 14727,
	"./arrow-right.svg": 33698,
	"./arrow-up.svg": 69339,
	"./bluetooth.svg": 75534,
	"./book.svg": 63007,
	"./camera.svg": 12669,
	"./catalog.svg": 33101,
	"./check-attendance.svg": 91840,
	"./check-mark.svg": 75670,
	"./circle-right.svg": 24173,
	"./close-2.svg": 64345,
	"./close.svg": 32484,
	"./comment.svg": 43615,
	"./copy.svg": 89911,
	"./cross.svg": 63784,
	"./delete-2.svg": 70896,
	"./delete.svg": 22681,
	"./download.svg": 30192,
	"./edit-2.svg": 67705,
	"./edit-3.svg": 55336,
	"./edit-4.svg": 57735,
	"./edit.svg": 37412,
	"./export.svg": 82402,
	"./filter.svg": 15342,
	"./head-phone.svg": 6133,
	"./help.svg": 35249,
	"./history.svg": 17144,
	"./man.svg": 68452,
	"./message.svg": 83557,
	"./more.svg": 59723,
	"./notice.svg": 57628,
	"./photo.svg": 48004,
	"./quit.svg": 38381,
	"./search.svg": 73564,
	"./share.svg": 75785,
	"./signal.svg": 55028,
	"./speaker-louder.svg": 21281,
	"./speaker.svg": 75011,
	"./switch.svg": 16140,
	"./text.svg": 41125,
	"./tips.svg": 19030,
	"./triangle.svg": 36244,
	"./upload-2.svg": 5134,
	"./upload.svg": 78795,
	"./women.svg": 59210,
	"./write.svg": 3357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20527;